import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { PDFDownloadLink } from '@react-pdf/renderer';
import BriefPDF from './BriefPDF';
import ReviewSubmit from './reviewSubmit';
import EventDetails from './eventDetails';
import RoomBlocks from './roomBlocks';
import MeetingSpaces from './meetingSpaces';
import Concessions from './concessions';
import PlannerInfo from './plannerInfo';
import AgencyInfo from './agencyInfo';
import KeyConsiderations from './keyConsiderations';
import AdditionalServices from './additionalServices';
import { SECTIONS } from '../../layouts/proposalRequestLevelLayout';

const SECTION_MAP = {
	review:         { component: ReviewSubmit,       title: 'Request Brief',        sub: 'A full summary of everything submitted in the wizard.' },
	event:          { component: EventDetails,       title: 'Event Details',        sub: 'Core details about the event the planner submitted.' },
	rooms:          { component: RoomBlocks,         title: 'Room Block',           sub: 'Daily guestroom requirements.' },
	agenda:         { component: MeetingSpaces,      title: 'Meeting Space',        sub: 'Sessions, rooms, and setup preferences.' },
	concessions:    { component: Concessions,        title: 'Concessions',          sub: 'Requested concessions to include in the proposal.' },
	considerations: { component: KeyConsiderations,  title: 'Key Considerations',   sub: 'Decision factors, history, and priorities.' },
	services:       { component: AdditionalServices, title: 'Additional Services',  sub: 'Extra services needed at the venue.' },
	planner:        { component: PlannerInfo,        title: 'Contract Signee',      sub: 'Who signs the contract for this event.' },
	agency:         { component: AgencyInfo,         title: 'Agency',               sub: 'Agency / commission information.' }
};

/**
 * Renders a single request section (one of the 9 wizard steps) inside the
 * white rounded content card. Matches the wizard's right-hand content area.
 */
class RequestSectionEditor extends Component {
	render() {
		const { request, requestId, orgId, refreshSectionCounts, match } = this.props;
		const sectionId = match.params.section;
		const def = SECTION_MAP[sectionId];

		if (!def) {
			return (
				<div className="pr-content-wrap">
					<div className="pr-content">
						<div className="pr-content-inner">
							<h1 className="pr-section-title">Section not found</h1>
							<p className="pr-section-sub">That request section doesn’t exist.</p>
						</div>
					</div>
				</div>
			);
		}

		const Comp = def.component;

		return (
			<div className="pr-content-wrap">
				<div className="pr-content">
					<div className="pr-content-inner">
						<div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 16, marginBottom: 4 }}>
							<div>
								<h1 className="pr-section-title">{def.title}</h1>
								<p className="pr-section-sub" style={{ marginBottom: 0 }}>{def.sub}</p>
							</div>
							{sectionId === 'review' && (
								<PDFDownloadLink
									document={<BriefPDF request={request} />}
									fileName={`${(request?.eventDetails?.eventName || 'proposal-request').replace(/\s+/g, '-').toLowerCase()}-brief.pdf`}
									style={{ textDecoration: 'none', flexShrink: 0 }}
								>
									{({ loading }) => (
										<button
											type="button"
											className="pr-review-edit-btn"
											style={{ display: 'flex', alignItems: 'center', gap: 6, cursor: loading ? 'wait' : 'pointer' }}
										>
											<i className="las la-file-pdf" />
											{loading ? 'Preparing\u2026' : 'Download PDF'}
										</button>
									)}
								</PDFDownloadLink>
							)}
						</div>

						<Comp
							request={request}
							requestId={requestId}
							orgId={orgId}
							refreshSectionCounts={refreshSectionCounts}
						/>
					</div>
				</div>
			</div>
		);
	}
}

export { SECTION_MAP };
export default withRouter(RequestSectionEditor);
